import * as mutationTypes from './types/mutation_types';
import * as actionsTypes from './types/action_types';
import * as getterTypes from './types/getter_types';

import { deleteMeal, fetchMeals, storeMeal, updateMeal } from '../services/meals';

export default {
  async [actionsTypes.FETCH_CAT_ING]({ commit }, options) {
    commit(mutationTypes.CAT_ING_REQUEST);
    const result = await fetchMeals(options).catch((e) => {
      commit(mutationTypes.CAT_ING_ERROR, e);
    });
    if (result) {
      commit(mutationTypes.CAT_ING_SUCCESS, result);
    }
    return result;
  },
  async [actionsTypes.STORE_CAT_ING]({ commit, getters }, payload) {
    commit(mutationTypes.CAT_ING_REQUEST);
    const result = await storeMeal(payload).catch((e) => {
      commit(mutationTypes.CAT_ING_ERROR, e);
    });
    if (result) {
      const categories = getters[getterTypes.DATA];
      categories.data.push(result.data);
      commit(mutationTypes.CAT_ING_SUCCESS, categories);
    }
    return result;
  },
  async [actionsTypes.UPDATE_CAT_ING]({ commit, getters }, payload) {
    const { id } = getters[getterTypes.SELECTED];
    commit(mutationTypes.CAT_ING_REQUEST);
    await updateMeal(id, payload).catch((e) => {
      commit(mutationTypes.CAT_ING_ERROR, e);
    });
    commit(mutationTypes.CAT_ING_SUCCESS, getters[getterTypes.DATA]);
  },
  async [actionsTypes.DELETE_CAT_ING]({ commit, getters }, id) {
    commit(mutationTypes.CAT_ING_REQUEST);
    const result = await deleteMeal(id).catch((e) => {
      commit(mutationTypes.CAT_ING_ERROR, e);
    });
    if (result) {
      const categories = getters[getterTypes.DATA];
      categories.data = categories.data.filter((branch) => branch.id !== id);
      commit(mutationTypes.CAT_ING_SUCCESS, categories);
    }
    return result;
  },
  [actionsTypes.SELECT_CAT_ING]({ commit }, payload) {
    commit(mutationTypes.CAT_ING_SELECT, payload);
  },
  [actionsTypes.SELECT_CAT_ING_RESET]({ commit }) {
    commit(mutationTypes.CAT_ING_SELECT_RESET);
  },
};
